interface ZodIssue {
  path?: (string | number)[];
  message?: string;
  code?: string;
}

interface ApiErrorBody {
  error?: string;
  message?: string;
  issues?: ZodIssue[];
}

interface HttpErrorLike {
  error?: ApiErrorBody | string;
  status?: number;
  message?: string;
}

/**
 * Turn whatever HttpClient handed us into a single user-readable line.
 * Surfaces zod issue paths so "invalid_body" tells the user which field is wrong.
 */
export function formatApiError(err: unknown, fallback = 'Something went wrong.'): string {
  const e = err as HttpErrorLike;
  const body = typeof e?.error === 'string' ? undefined : e?.error;

  if (body?.issues?.length) {
    const first = body.issues[0]!;
    const path = (first.path ?? []).join('.') || '(root)';
    const msg = first.message || first.code || 'invalid';
    const more = body.issues.length > 1 ? ` (+${body.issues.length - 1} more)` : '';
    return `${path}: ${msg}${more}`;
  }

  if (body?.message) return body.message;
  if (body?.error) return body.error;
  if (typeof e?.error === 'string') return e.error;
  if (e?.status === 0) return 'Could not reach the server.';
  if (e?.message) return e.message;
  return fallback;
}
